import { createSelector } from '@reduxjs/toolkit'

import { selectBusinessPrioritiesState } from './selectBusinessPrioritiesState'

export const selectGeoMarkets = createSelector(
  [selectBusinessPrioritiesState],
  (state) => state.geoMarkets
)
